const CheckmarkTimed = () => (
  <>
    <path
      fill="currentColor"
      d="m15.893 8.9-5.54 5.558-2.246-2.265a.48.48 0 0 0-.355-.14.477.477 0 0 0-.493.494q0 .214.14.353l2.39 2.37q.241.242.565.242.322 0 .565-.242L16.6 9.607a.48.48 0 0 0 .14-.355.477.477 0 0 0-.494-.493.47.47 0 0 0-.353.14"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.342 3.663A8.5 8.5 0 0 1 20.5 12a.5.5 0 0 1-1 0 7.5 7.5 0 1 0-7.5 7.5.5.5 0 0 1 0 1 8.5 8.5 0 0 1-1.658-16.837"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18 22a4 4 0 1 0 0-8 4 4 0 0 0 0 8m.5-6a.5.5 0 0 0-1 0v2a.5.5 0 0 0 .146.354l1.5 1.5a.5.5 0 0 0 .708-.707L18.5 17.793z"
      clipRule="evenodd"
    />
  </>
)
export default CheckmarkTimed
